import httpClient from '../api/createAxiosHttpClient';
import { useAuthStore } from '../stores/authStore';

// Hook para usar el httpClient con garantía de hidratación
export const useHttpClient = () => {
  const hasHydrated = useAuthStore((state) => state.hasHydrated);

  if (!hasHydrated) {
    console.warn('Using HTTP client before auth store hydration');
  }

  return httpClient;
};
